import { BrowserRouter as Router, Route } from "react-router-dom";
import ProspectReg from "./prospect_reg";
import MyAccountReg from "./myaccount_reg";
import RetailReg from "./retail_reg";
import BackOfficeReg from "./backoffice_reg";
import FundboardReg from "./fundboard_reg";
import EntityOwnedReg from "./entityOwned_reg";
import Registration from "./registration";
import MyTeamsAssistantReg from "./MyTeamsAssistantReg";
import {
    TPIA,
    INTERNAL,
    RIA_FIRM,
    WHOLESALER,
    ANNUITIES_FP_PATH,
    RIA_PATH,
    MYACCOUNT_PATH,
    BACKOFFICE_PATH,
    FUNDBOARD_PATH,
    ENTITY_OWNED_PATH,
    TPIA_PATH,
    INTERNAL_PATH,
    WHOLESALER_PATH,
    RIA_FIRM_PATH,
    MY_TEAMS_ASSISTANT_PATH
} from "./constants";
import "./styles/App.scss";

function App() {
    return (
        <div className="App">
            <Router basename={process.env.PUBLIC_URL}>
                <Route exact path={ANNUITIES_FP_PATH} component={RetailReg} />
                <Route exact path={RIA_PATH} component={ProspectReg} />
                <Route exact path={MYACCOUNT_PATH} component={MyAccountReg} />
                <Route
                    exact
                    path={ENTITY_OWNED_PATH}
                    component={EntityOwnedReg}
                />
                <Route exact path={FUNDBOARD_PATH} component={FundboardReg} />
                <Route exact path={BACKOFFICE_PATH} component={BackOfficeReg} />
                <Route
                    exact
                    path={MY_TEAMS_ASSISTANT_PATH}
                    component={MyTeamsAssistantReg}
                />
                <Route exact path={TPIA_PATH}>
                    <Registration userRole={TPIA} />
                </Route>
                <Route exact path={INTERNAL_PATH}>
                    <Registration userRole={INTERNAL} />
                </Route>
                <Route exact path={WHOLESALER_PATH}>
                    <Registration userRole={WHOLESALER} />
                </Route>
                <Route exact path={RIA_FIRM_PATH}>
                    <Registration userRole={RIA_FIRM} />
                </Route>
            </Router>
        </div>
    );
}
export default App;
